import type { MapProgressData } from '../MapProgress';
import { SAVE_STORAGE_KEY, type SaveProvider } from './SaveProvider';

export class LocalStorageSaveProvider implements SaveProvider {
  readonly name = 'localStorage';

  static isAvailable(): boolean {
    try {
      if (typeof window === 'undefined' || !window.localStorage) return false;
      // Тест что localStorage реально работает (приватный режим Safari может бросать).
      const testKey = '__fg_test__';
      window.localStorage.setItem(testKey, '1');
      window.localStorage.removeItem(testKey);
      return true;
    } catch {
      return false;
    }
  }

  async save(data: MapProgressData): Promise<void> {
    window.localStorage.setItem(SAVE_STORAGE_KEY, JSON.stringify(data));
  }

  async load(): Promise<MapProgressData | null> {
    const raw = window.localStorage.getItem(SAVE_STORAGE_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as MapProgressData;
    } catch {
      return null;
    }
  }

  async clear(): Promise<void> {
    window.localStorage.removeItem(SAVE_STORAGE_KEY);
  }
}
